import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, BarChart3, Users, Building2, MapPin, Phone, ArrowRight, Quote, Award, GraduationCap, Trophy, Target, ClipboardList, MessageCircle, Flame, ChevronDown, Check } from 'lucide-react';
export function Home() {
  return <div className="w-full" data-id="element-417">
      <Hero data-id="element-418" />
      <LocationStrip data-id="element-419" />
      <StatsStrip data-id="element-420" />
      <Programs data-id="element-421" />
      <HowItWorks data-id="element-422" />
      <WhyReach data-id="element-423" />
      <MeetTheCoach data-id="element-424" />
      <CoachInAction data-id="element-425" />
      <ProAthletes data-id="element-426" />
      <StrengthInFocus data-id="element-427" />
      <Testimonials data-id="element-428" />
      <TrainingInMotion data-id="element-429" />
      <AthletesInAction data-id="element-430" />
      <FAQPreview data-id="element-431" />
      <FinalCta data-id="element-432" />
    </div>;
}
/* ---------- 1. HERO ---------- */
function Hero() {
  return <section className="relative h-screen min-h-[640px] w-full flex items-center justify-center overflow-hidden bg-reach-black" data-id="element-433">
      <div className="absolute inset-0 z-0" data-id="element-434">
        <img src="https://cdn.magicpatterns.com/uploads/rgLqfeYbfsME5fh7JYem7K/_DSC2694_2.jpg" alt="Reach Performance athletes training on the field" className="w-full h-full object-cover object-center photo-editorial" style={{
        filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
      }} data-id="element-435" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(to bottom, rgba(0,0,0,0.55), rgba(0,0,0,0.78))'
      }} data-id="element-436" />
        <div className="absolute inset-0 bg-reach-red mix-blend-multiply opacity-[0.08]" data-id="element-437" />
      </div>

      <div className="absolute inset-0 z-10 pointer-events-none overflow-hidden" data-id="element-438">
        <div className="absolute top-1/3 -left-40 w-[60%] h-2 bg-reach-red transform -rotate-[8deg] opacity-60" data-id="element-439" />
        <div className="absolute top-[42%] -left-40 w-[45%] h-2 bg-reach-red transform -rotate-[8deg] opacity-40" data-id="element-440" />
        <div className="absolute top-[50%] -left-40 w-[30%] h-2 bg-reach-red transform -rotate-[8deg] opacity-30" data-id="element-441" />
      </div>

      <div className="relative z-20 max-w-container mx-auto px-4 md:px-8 text-center" data-id="element-442">
        <h1 className="font-bebas text-white text-[56px] sm:text-7xl md:text-8xl lg:text-[96px] leading-[0.9] tracking-wide mb-5" data-id="element-443">
          Train with us
        </h1>
        <p className="font-inter text-reach-red text-base sm:text-lg md:text-2xl uppercase tracking-[0.25em] font-semibold mb-6" data-id="element-444">
          Summer Season · June 1 to August 8
        </p>
        <p className="font-inter text-white md:text-xl max-w-2xl mx-auto mb-10 text-[16px]" data-id="element-445">
          Speed, strength, and athletic development for youth to pro athletes in
          McKinney, TX.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center max-w-md sm:max-w-none mx-auto" data-id="element-446">
          <Link to="/pricing" className="btn-primary sm:w-auto" data-id="element-447">
            Enroll Now
          </Link>
          <Link to="/book" className="btn-secondary-dark sm:w-auto" data-id="element-448">
            Book Free Consultation
          </Link>
        </div>
      </div>
    </section>;
}
/* ---------- 2. LOCATION STRIP ---------- */
function LocationStrip() {
  return <section className="bg-reach-black border-y border-white/10" data-id="element-449">
      <div className="max-w-container mx-auto px-4 md:px-8 py-4 md:py-5" data-id="element-450">
        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-8 text-white text-center" data-id="element-451">
          <a href="https://maps.google.com/?q=6051+Alma+Rd,+McKinney,+TX+75070" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 font-inter text-sm md:text-base hover:text-reach-red transition-colors" data-id="element-452">
            <MapPin size={16} className="text-reach-red" data-id="element-453" />
            <span className="uppercase tracking-wider" data-id="element-454">
              INPOWERiQ · 6051 Alma Rd · McKinney, TX
            </span>
          </a>
          <span className="hidden md:inline text-white/30" data-id="element-455">|</span>
          <a href="tel:7089804666" className="flex items-center gap-2 font-inter text-sm md:text-base hover:text-reach-red transition-colors" data-id="element-456">
            <Phone size={16} className="text-reach-red" data-id="element-457" />
            <span className="uppercase tracking-wider" data-id="element-458">(708) 980-4666</span>
          </a>
        </div>
      </div>
    </section>;
}
/* ---------- 3. STATS STRIP ---------- */
function StatsStrip() {
  const stats = [{
    num: '10 yrs',
    label: 'Coaching experience'
  }, {
    num: '500+',
    label: 'Athletes trained'
  }, {
    num: '4',
    label: 'Pro leagues represented'
  }, {
    num: '7',
    label: 'Sports specialized'
  }];
  return <section className="bg-white py-16 md:py-20 border-b border-black/5" data-id="element-459">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-460">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-10 gap-x-6" data-id="element-461">
          {stats.map((s, i) => <div key={s.label} className={`text-center lg:text-left ${i !== 0 ? 'lg:border-l lg:border-black/10 lg:pl-6' : ''}`} data-id="element-462">
              <p className="font-bebas text-reach-red text-5xl md:text-6xl lg:text-7xl leading-none mb-3 tracking-wide" data-id="element-463">
                {s.num}
              </p>
              <p className="font-inter text-reach-black/80 text-xs md:text-sm uppercase tracking-[0.2em]" data-id="element-464">
                {s.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}
/* ---------- 4. PROGRAMS ---------- */
interface ProgramCardProps {
  label: string;
  title: string;
  body: string;
  price: string;
}
function ProgramCard({
  label,
  title,
  body,
  price
}: ProgramCardProps) {
  return <div className="group bg-reach-black text-white p-8 md:p-10 rounded-[4px] transition-all duration-200 ease-out hover:-translate-y-1 border-b-4 border-transparent hover:border-reach-red flex flex-col h-full" data-id="element-465">
      <p className="font-inter text-reach-red text-xs uppercase tracking-[0.25em] font-semibold mb-4" data-id="element-466">
        {label}
      </p>
      <h3 className="font-bebas text-3xl md:text-4xl tracking-wide leading-none mb-5" data-id="element-467">
        {title}
      </h3>
      <p className="font-inter text-white/80 text-base mb-6 leading-relaxed" data-id="element-468">
        {body}
      </p>
      <p className="font-bebas text-2xl md:text-3xl tracking-wide mb-8" data-id="element-469">
        {price}
      </p>
      <div className="mt-auto" data-id="element-470">
        <Link to="/pricing" className="inline-flex items-center gap-2 font-inter font-semibold text-sm uppercase tracking-wider text-white group-hover:text-reach-red transition-colors" data-id="element-471">
          See Schedule & Enroll
          <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" data-id="element-472" />
        </Link>
      </div>
    </div>;
}
function Programs() {
  return <section className="bg-white py-20 md:py-28" data-id="element-473">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-474">
        <div className="text-center mb-14" data-id="element-475">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-476">
            Summer 2026 Programs
          </p>
          <h2 className="font-bebas text-4xl md:text-6xl tracking-wide" data-id="element-477">
            Built by Age & Stage
          </h2>
          <p className="font-inter text-reach-black/70 text-base md:text-lg mt-4 max-w-2xl mx-auto" data-id="element-478">
            Three programs, each built for where your athlete is right now, not
            where someone else is.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-stretch" data-id="element-479">
          <ProgramCard label="Youth · Ages 8–10" title="Foundations" body="60-min sessions · 2 weekly time slots" price="From $270/mo" data-id="element-480" />
          <ProgramCard label="Middle School · Ages 11–13" title="Performance Prep" body="60-min sessions · 5 weekly time slots" price="From $270/mo" data-id="element-481" />
          <ProgramCard label="High School · Ages 14+" title="Advanced Performance" body="75-min sessions · 5 weekly time slots" price="From $325/mo" data-id="element-482" />
        </div>

        <div className="text-center mt-12" data-id="element-483">
          <Link to="/programs" className="btn-secondary" data-id="element-484">
            See all programs & schedules
            <ArrowRight size={16} className="ml-2" data-id="element-485" />
          </Link>
        </div>
      </div>
    </section>;
}
/* ---------- 5. MEET THE COACH ---------- */
function MeetTheCoach() {
  const credentials = ['10+ years coaching athletes from youth to professional level', '500+ athletes trained across 7 sports and 4 professional leagues', 'Specializes in periodized speed, strength, and athletic development'];
  return <section className="relative" style={{
    backgroundColor: '#0A0A0A'
  }} data-id="element-486">
      <div className="max-w-container mx-auto px-4 md:px-8 py-20 md:py-[120px]" data-id="element-487">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-488">
          {/* LEFT: Photo */}
          <div className="relative w-full lg:max-h-[600px] overflow-hidden bg-black flex items-center justify-center" data-id="element-489">
            <img src="https://cdn.magicpatterns.com/uploads/hnUCxo7mmgCBQyaKxi38nE/FernandoB_Dec2022-22_1.jpg" alt="Fernando Beltran, Director of Performance at Reach Performance" className="w-full h-full object-contain lg:max-h-[600px]" style={{
            filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
          }} data-id="element-490" />
            {/* Red accent bar, top-left corner */}
            <div className="absolute top-0 left-0" style={{
            width: '4px',
            height: '80px',
            backgroundColor: '#C8102E'
          }} data-id="element-491" />
          </div>

          {/* RIGHT: Text */}
          <div className="text-white" data-id="element-492">
            <p className="font-inter uppercase font-semibold mb-5" style={{
            color: '#C8102E',
            fontSize: '14px',
            letterSpacing: '2px'
          }} data-id="element-493">
              Meet the Director
            </p>
            <h2 className="font-bebas text-white mb-4" style={{
            fontSize: 'clamp(56px, 8vw, 80px)',
            lineHeight: 0.95
          }} data-id="element-494">
              Fernando Beltran
            </h2>
            <p className="font-inter italic mb-8" style={{
            color: '#C8102E',
            fontSize: '18px'
          }} data-id="element-495">
              Director of Performance · Reach Performance LLC
            </p>

            <div className="space-y-5 font-inter text-white mb-8" style={{
            fontSize: '18px',
            lineHeight: 1.6
          }} data-id="element-496">
              <p data-id="element-497">
                Coach Fernando Beltran has spent the last decade building
                athletic performance programs for athletes ranging from youth to
                professional level. He founded Reach Performance after seeing
                too many youth athletes plateau on random workouts that did not
                fit their stage of development.
              </p>
              <p data-id="element-498">
                Every Reach program is periodized. That means every session has
                a purpose and the work compounds across the season. No random
                circuits. No filler. Every athlete is tested on the same markers
                every 4 weeks so progress is measurable, not vibes based.
              </p>
              <p data-id="element-499">
                Reach Performance trains out of INPOWERIQ Performance Center in
                McKinney, Texas, where a 24,000 square foot facility houses
                everything from speed gates to recovery tools. The mission is
                simple: train athletes the way they deserve to be trained.
              </p>
            </div>

            <ul className="space-y-3 mb-10" data-id="element-500">
              {credentials.map(item => <li key={item} className="flex items-start gap-3" data-id="element-501">
                  <Check size={16} style={{
                color: '#C8102E'
              }} className="mt-1 shrink-0" strokeWidth={2.5} data-id="element-502" />
                  <span className="font-inter text-white" style={{
                fontSize: '16px'
              }} data-id="element-503">
                    {item}
                  </span>
                </li>)}
            </ul>

            <Link to="/about" className="inline-flex items-center gap-2 font-inter font-semibold uppercase tracking-[0.2em] text-sm no-underline hover:underline" style={{
            color: '#C8102E'
          }} data-id="element-504">
              Read the Full Story
              <ArrowRight size={18} data-id="element-505" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}
/* ---------- NEW: PRO ATHLETES ---------- */
function ProAthletes() {
  return <section id="pro-athletes" className="bg-black py-20 md:py-[120px]" data-id="element-506">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-507">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center" data-id="element-508">
          {/* LEFT: Text */}
          <div className="w-full lg:w-[60%] text-white" data-id="element-509">
            <p className="font-inter uppercase font-semibold mb-4" style={{
            color: '#C8102E',
            fontSize: '14px',
            letterSpacing: '2px'
          }} data-id="element-510">
              PRO ATHLETES
            </p>
            <h2 className="font-bebas text-white mb-6" style={{
            fontSize: 'clamp(56px, 8vw, 80px)',
            lineHeight: 0.95
          }} data-id="element-511">
              BUILT FOR THE NEXT LEVEL
            </h2>
            <p className="font-inter text-white text-[18px] mb-8 leading-relaxed" data-id="element-512">
              Reach Performance also trains professional and collegiate athletes
              preparing for combines, off-seasons, recruiting tape, and pro
              contracts. Programming is fully individualized: position-specific
              work, recovery protocols, and on-call coach access. By application
              only.
            </p>
            <ul className="space-y-3 mb-10" data-id="element-513">
              {['1-on-1 or small-group sessions, max 4 athletes', 'Custom programming reviewed weekly', 'Performance testing every 2 weeks', 'On-call coach access between sessions'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-514">
                  <Check size={16} style={{
                color: '#C8102E'
              }} className="mt-1 shrink-0" strokeWidth={2.5} data-id="element-515" />
                  <span className="font-inter text-white text-[16px]" data-id="element-516">
                    {item}
                  </span>
                </li>)}
            </ul>
            <div className="mb-8" data-id="element-517">
              <p className="font-bebas text-[#C8102E] text-[32px] tracking-wide leading-none mb-1" data-id="element-518">
                PRICING BY INQUIRY
              </p>
              <p className="font-inter text-white text-[14px] italic" data-id="element-519">
                Reach out to discuss your goals. We build the package together.
              </p>
            </div>
            <Link to="/book" className="inline-flex items-center justify-center bg-[#C8102E] text-white font-bebas text-[18px] tracking-wide px-[32px] h-[56px] rounded-[4px] transition-all duration-200 ease-out hover:bg-reach-black hover:text-white uppercase hover:-translate-y-[3px]" data-id="element-520">
              INQUIRE NOW
            </Link>
          </div>

          {/* RIGHT: Photo Grid */}
          <div className="w-full lg:w-[40%]" data-id="element-521">
            <div className="grid grid-cols-2 gap-2" data-id="element-522">
              <img src="https://cdn.magicpatterns.com/uploads/6nE1uHsqErzRXLfd7M7FCY/DSC08415.jpg" alt="Pro athlete training, barbell work" className="w-full aspect-square md:aspect-[4/5] object-cover rounded-[4px]" style={{
              filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
            }} data-id="element-523" />
              <img src="https://cdn.magicpatterns.com/uploads/eJpwVLJRNzMoHCRmuDdwSs/DSC08435.jpg" alt="Pro athlete training, trap bar deadlift" className="w-full aspect-square md:aspect-[4/5] object-cover rounded-[4px]" style={{
              filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
            }} data-id="element-524" />
              <img src="https://cdn.magicpatterns.com/uploads/oCamE4i7LWqKb8zkX48MGc/DSC08438.jpg" alt="Pro athlete training, suspension pull" className="w-full aspect-square md:aspect-[4/5] object-cover rounded-[4px]" style={{
              filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
            }} data-id="element-525" />
              <img src="https://cdn.magicpatterns.com/uploads/oYW9kpN5gW71b35rwwmtPx/DSC08450.jpg" alt="Pro athlete training, focused barbell work" className="w-full aspect-square md:aspect-[4/5] object-cover rounded-[4px]" style={{
              filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
            }} data-id="element-526" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}
/* ---------- 6. HOW IT WORKS ---------- */
function HowItWorks() {
  const steps = [{
    num: '01',
    Icon: ClipboardList,
    title: "Pick your athlete's program",
    body: 'Three tiers built by age and stage: Foundations (8–10), Performance Prep (11–13), and Advanced (14+).',
    cta: {
      label: 'See Programs',
      to: '/programs'
    }
  }, {
    num: '02',
    Icon: MessageCircle,
    title: 'Book a free 15-min consultation',
    body: "Not sure where to start? Talk through your athlete's goals with Coach Fernando and get a recommendation.",
    cta: {
      label: 'Book Consultation',
      to: '/book'
    }
  }, {
    num: '03',
    Icon: Flame,
    title: 'Start training on June 1',
    body: 'Periodized programming, performance testing every 4 weeks, and small groups capped at 8 athletes.',
    cta: {
      label: 'Enroll Now',
      to: '/pricing'
    }
  }];
  return <section className="bg-white py-20 md:py-28" data-id="element-527">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-528">
        <div className="text-center mb-14" data-id="element-529">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-530">
            How It Works
          </p>
          <h2 className="font-bebas text-4xl md:text-6xl tracking-wide" data-id="element-531">
            Get Started in 3 Steps
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-stretch relative" data-id="element-532">
          {/* Connecting line on desktop */}
          <div className="hidden md:block absolute top-12 left-[16.66%] right-[16.66%] h-0.5 bg-reach-gray z-0" data-id="element-533">
            <div className="h-full bg-reach-red w-1/3" data-id="element-534" />
          </div>

          {steps.map(s => <div key={s.num} className="relative z-10 bg-reach-gray rounded-[4px] p-7 md:p-8 border-b-4 border-transparent hover:border-reach-red transition-all duration-200 ease-out flex flex-col" data-id="element-535">
              <div className="flex items-center gap-4 mb-5" data-id="element-536">
                <div className="w-14 h-14 bg-reach-black rounded-[4px] flex items-center justify-center shrink-0" data-id="element-537">
                  <s.Icon size={22} className="text-reach-red" data-id="element-538" />
                </div>
                <span className="font-bebas text-reach-red text-4xl tracking-wide leading-none" data-id="element-539">
                  {s.num}
                </span>
              </div>
              <h3 className="font-bebas text-2xl md:text-3xl tracking-wide uppercase leading-tight mb-3" data-id="element-540">
                {s.title}
              </h3>
              <p className="font-inter text-reach-black/80 text-base leading-relaxed mb-6" data-id="element-541">
                {s.body}
              </p>
              <Link to={s.cta.to} className="mt-auto inline-flex items-center gap-2 font-inter font-semibold text-sm uppercase tracking-wider text-reach-black hover:text-reach-red transition-colors" data-id="element-542">
                {s.cta.label}
                <ArrowRight size={16} data-id="element-543" />
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}
/* ---------- 7. WHY REACH ---------- */
interface WhyItemProps {
  Icon: ComponentType<{
    size?: number;
    className?: string;
  }>;
  title: string;
  body: string;
}
function WhyItem({
  Icon,
  title,
  body
}: WhyItemProps) {
  return <div className="text-center" data-id="element-544">
      <div className="w-16 h-16 bg-reach-black rounded-[4px] flex items-center justify-center mx-auto mb-5" data-id="element-545">
        <Icon size={28} className="text-reach-red" data-id="element-546" />
      </div>
      <h3 className="font-bebas text-xl md:text-2xl tracking-wide mb-3 uppercase" data-id="element-547">
        {title}
      </h3>
      <p className="font-inter text-reach-black text-base leading-relaxed" data-id="element-548">
        {body}
      </p>
    </div>;
}
function WhyReach() {
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-549">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-550">
        <div className="text-center mb-14" data-id="element-551">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-552">
            What Makes Us Different
          </p>
          <h2 className="font-bebas text-4xl md:text-5xl tracking-wide" data-id="element-553">
            Why Reach
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10" data-id="element-554">
          <WhyItem Icon={Calendar} title="Periodized Programming" body="Every day has a purpose. No random workouts." data-id="element-555" />
          <WhyItem Icon={BarChart3} title="Testing Every 4 Weeks" body="Real data. Real progress. Tracked." data-id="element-556" />
          <WhyItem Icon={Users} title="Max 8 Athletes Per Session" body="Every athlete gets coached." data-id="element-557" />
          <WhyItem Icon={Building2} title="24,000 Sq Ft Facility" body="Speed gates, indoor turf, recovery zone." data-id="element-558" />
        </div>
      </div>
    </section>;
}
/* ---------- 8. TESTIMONIALS ---------- */
const TESTIMONIALS = [{
  tier: 'Youth · Ages 8–10',
  quote: "My 9-year-old went from being the kid who tripped over himself to one of the fastest on his soccer team. The coaches make it fun, but he's also learning real movement skills.",
  name: 'Jessica P.',
  role: 'Parent · Youth Soccer · McKinney'
}, {
  tier: 'Middle School · Ages 11–13',
  quote: 'Reach is the first place that actually treats my 7th grader like an athlete, not a kid. He looks forward to training and asks about his test numbers all the time.',
  name: 'Daniel R.',
  role: 'Parent · MS Basketball · Frisco'
}, {
  tier: 'High School · Ages 14+',
  quote: 'My son added 4 inches to his vertical and dropped his 40 by three tenths in one summer. The testing every month shows him the work is paying off, and he wants to be in the gym.',
  name: 'Marcus T.',
  role: 'Parent · Varsity Football · Prosper HS'
}, {
  tier: 'Collegiate',
  quote: 'Came home from D1 ball needing to clean up my mechanics and add real speed. Fernando built a plan around my position and my off-season. I came back to campus stronger and faster, on paper.',
  name: 'Tyler M.',
  role: 'D1 Baseball · Allen, TX'
}];
function Testimonials() {
  return <section className="bg-reach-black py-20 md:py-28 relative overflow-hidden" data-id="element-559">
      <div className="absolute top-0 -left-20 w-[40%] h-1 bg-reach-red transform rotate-[3deg] opacity-50" data-id="element-560" />
      <div className="absolute bottom-0 -right-20 w-[40%] h-1 bg-reach-red transform rotate-[3deg] opacity-50" data-id="element-561" />

      <div className="max-w-container mx-auto px-4 md:px-8 relative" data-id="element-562">
        <div className="text-center mb-14" data-id="element-563">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-564">
            From the families we train
          </p>
          <h2 className="font-bebas text-white text-4xl md:text-6xl tracking-wide leading-none" data-id="element-565">
            Real Athletes. Real Results.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-566">
          {TESTIMONIALS.map(t => <article key={t.name} className="relative bg-white/[0.04] border border-white/10 rounded-[4px] p-7 md:p-9 hover:border-reach-red transition-colors duration-200 ease-out flex flex-col" data-id="element-567">
              <Quote size={32} className="text-reach-red mb-4 shrink-0" aria-hidden="true" data-id="element-568" />
              <p className="font-inter text-white text-base md:text-lg leading-relaxed mb-7" data-id="element-569">
                "{t.quote}"
              </p>
              <div className="mt-auto pt-5 border-t border-white/10" data-id="element-570">
                <p className="font-bebas text-white text-lg tracking-wider leading-none mb-1" data-id="element-571">
                  {t.name}
                </p>
                <p className="font-inter text-white/60 text-xs uppercase tracking-[0.2em]" data-id="element-572">
                  {t.role}
                </p>
                <p className="font-inter text-reach-red text-[10px] uppercase tracking-[0.25em] font-semibold mt-2" data-id="element-573">
                  {t.tier}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}
/* ---------- NEW: ATHLETES IN ACTION ---------- */
function AthletesInAction() {
  const photos = ['https://cdn.magicpatterns.com/uploads/wWmiutbZWe7EzeJHJe2mA5/3C9A1117.jpg', 'https://cdn.magicpatterns.com/uploads/991rnpezM2GADobD58DKrT/3C9A1865.jpg', 'https://cdn.magicpatterns.com/uploads/qMjKZW22fqPwVx6apSpTzf/3C9A2088.jpg', 'https://cdn.magicpatterns.com/uploads/pDZpQp1wsBC5rHNufWUdxV/3C9A2184.jpg', 'https://cdn.magicpatterns.com/uploads/kbEHN4CtCp4EVRtQaqvkCz/3C9A2306.jpg', 'https://cdn.magicpatterns.com/uploads/8RR88uUq93cGUn52sAtucr/45.jpg', 'https://cdn.magicpatterns.com/uploads/wLqiBaGFFnkTk39ZX3FBPC/46.jpg', 'https://cdn.magicpatterns.com/uploads/rekESqpBG6TTttVJJEv9k7/47.jpg', 'https://cdn.magicpatterns.com/uploads/2BBDLYkWnpjH7hzRVKkTZS/49.jpg', 'https://cdn.magicpatterns.com/uploads/aYEWfC3UupnJby3VHtvueu/8.jpg', 'https://cdn.magicpatterns.com/uploads/aE79ddngrTZ7D6SZfJc3w6/DSC08251.jpg', 'https://cdn.magicpatterns.com/uploads/4J323wqfFTjvy4CVGtKDbj/4.jpg'];
  return <section className="bg-[#F5F5F5] py-20 md:py-[120px]" data-id="element-574">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-575">
        <div className="text-center mb-14" data-id="element-576">
          <p className="font-inter uppercase font-semibold mb-3 mx-auto" style={{
          color: '#C8102E',
          fontSize: '14px',
          letterSpacing: '2px'
        }} data-id="element-577">
            ATHLETES WE TRAIN
          </p>
          <h2 className="font-bebas text-black mb-4 mx-auto" style={{
          fontSize: 'clamp(56px, 8vw, 80px)',
          lineHeight: 0.95
        }} data-id="element-578">
            IN THE FIELD
          </h2>
          <p className="font-inter italic text-gray-600 text-[18px] max-w-[640px] mx-auto" data-id="element-579">
            Snapshots from real training sessions and athlete shoots.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-580">
          {photos.map((src, i) => <img key={i} src={src} alt="Athlete in action" className="w-full aspect-[4/5] object-cover rounded-[4px]" style={{
          filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
        }} data-id="element-581" />)}
        </div>
      </div>
    </section>;
}
/* ---------- NEW: COACH IN ACTION ---------- */
function CoachInAction() {
  const items = [{
    src: 'https://cdn.magicpatterns.com/uploads/7z4cnkTJZM2DpBeJYoPKoy/_DSC2827.jpg',
    alt: 'Coach Fernando with athletes between sets',
    caption: 'Coach Fernando with the post-session group.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/4a5UQAPYnz41u5HFuB6ioV/3C9A2101.jpg',
    alt: 'Reach Performance athlete working ball control on outdoor turf',
    caption: 'Ball control work between sets, outdoor turf.'
  }];
  return <section className="bg-reach-black py-16 md:py-20 relative overflow-hidden" data-id="element-582">
      <div className="absolute top-0 left-0 w-[40%] h-1 bg-reach-red opacity-50" data-id="element-583" />
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-584">
        <p className="font-inter uppercase font-semibold mb-8" style={{
        color: '#C8102E',
        fontSize: '14px',
        letterSpacing: '2px'
      }} data-id="element-585">
          COACH IN ACTION
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-586">
          {items.map(item => <figure key={item.src} className="m-0" data-id="element-587">
              <img src={item.src} alt={item.alt} className="w-full aspect-[3/4] object-cover rounded-[4px]" style={{
            filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
          }} data-id="element-588" />
              <figcaption className="font-inter italic mt-3" style={{
            color: '#9CA3AF',
            fontSize: '12px'
          }} data-id="element-589">
                {item.caption}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}
/* ---------- NEW: STRENGTH IN FOCUS ---------- */
function StrengthInFocus() {
  const items = [{
    src: 'https://cdn.magicpatterns.com/uploads/f3t9AXfrUc4HCjj5i8RWmd/DSC08293.jpg',
    alt: 'Athlete performing TRX suspension work'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/r3gsDvxc9TfQd8WQapFpKs/DSC08447.jpg',
    alt: 'Athlete holding a loaded barbell in focused stance'
  }];
  return <section className="bg-black py-16 md:py-20 relative overflow-hidden" data-id="element-590">
      <div className="absolute top-0 right-0 w-[40%] h-1 bg-reach-red opacity-50" data-id="element-591" />
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-592">
        <p className="font-inter uppercase font-semibold mb-8 text-right" style={{
        color: '#C8102E',
        fontSize: '14px',
        letterSpacing: '2px'
      }} data-id="element-593">
          STRENGTH IN FOCUS
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-594">
          {items.map(item => <img key={item.src} src={item.src} alt={item.alt} className="w-full aspect-[3/4] object-cover rounded-[4px]" style={{
          filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
        }} data-id="element-595" />)}
        </div>
      </div>
    </section>;
}
/* ---------- NEW: TRAINING IN MOTION ---------- */
function TrainingInMotion() {
  const stills = ['https://cdn.magicpatterns.com/uploads/rSepDZt54JgkGq2Jn4nL9N/20260417_C1306.00_04_14_03.Still004.jpg', 'https://cdn.magicpatterns.com/uploads/vdqpYih85sP5kzpBFukVvn/20260417_C1306.00_08_02_05.Still006.jpg', 'https://cdn.magicpatterns.com/uploads/s3QoMBLZdYTfzm1napiuWd/20260417_C1306.00_17_04_16.Still020.jpg', 'https://cdn.magicpatterns.com/uploads/hMRk4ub5jPVSkDSg6Jviez/20260417_C1306.00_17_14_07.Still022.jpg', 'https://cdn.magicpatterns.com/uploads/fu8FsrLg4GMr8nHT5VFWtZ/20260417_C1306.00_18_22_16.Still030.jpg', 'https://cdn.magicpatterns.com/uploads/d2Tj3KKCMQKkQKBJxGdf7K/20260417_C1306.00_27_59_14.Still046.jpg'];
  return <section className="bg-black py-20 md:py-[120px] relative overflow-hidden" data-id="element-596">
      <div className="absolute top-1/2 -left-20 w-[40%] h-1 bg-reach-red transform -rotate-[3deg] opacity-40" data-id="element-597" />
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-598">
        <div className="text-center mb-12" data-id="element-599">
          <p className="font-inter uppercase font-semibold mb-3" style={{
          color: '#C8102E',
          fontSize: '14px',
          letterSpacing: '2px'
        }} data-id="element-600">
            TRAINING IN MOTION
          </p>
          <h2 className="font-bebas text-white" style={{
          fontSize: 'clamp(48px, 7vw, 72px)',
          lineHeight: 0.95
        }} data-id="element-601">
            WHAT A SESSION LOOKS LIKE
          </h2>
        </div>
      </div>
      <div className="overflow-x-auto snap-x snap-mandatory" data-id="element-602">
        <div className="flex gap-3 md:gap-4 px-4 md:px-8 pb-6 w-max" data-id="element-603">
          {stills.map((src, i) => <div key={i} className="flex-none w-[280px] sm:w-[320px] aspect-[9/16] bg-black rounded-[4px] overflow-hidden snap-start" data-id="element-604">
              <img src={src} alt="Training session, video still" className="w-full h-full object-cover" style={{
            filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
          }} data-id="element-605" />
            </div>)}
        </div>
      </div>
    </section>;
}
/* ---------- 9. FAQ PREVIEW ---------- */
const FAQS = [{
  q: 'What if my athlete has never trained before?',
  a: 'Perfect starting point. Foundations and Performance Prep are built for first-time athletes. Every program starts with teaching mechanics before adding load.'
}, {
  q: 'What if my athlete misses a session?',
  a: 'Every monthly enrollment includes one free make-up per month in any age-appropriate class, subject to availability.'
}, {
  q: 'Do you offer a sibling discount?',
  a: 'Yes. Additional siblings receive 10% off their monthly plan, applied at checkout.'
}, {
  q: 'What should my athlete bring to a session?',
  a: 'Athletic shoes (turf or trainers), a water bottle, and athletic clothing. We provide all training equipment, speed gates, and access to the recovery zone.'
}];
function FAQPreview() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white py-20 md:py-28" data-id="element-606">
      <div className="max-w-3xl mx-auto px-4 md:px-8" data-id="element-607">
        <div className="text-center mb-12" data-id="element-608">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-609">
            Parents Ask
          </p>
          <h2 className="font-bebas text-4xl md:text-5xl tracking-wide" data-id="element-610">
            Common Questions
          </h2>
        </div>

        <div className="space-y-2" data-id="element-611">
          {FAQS.map((item, i) => {
          const isOpen = open === i;
          return <div key={item.q} className="bg-reach-gray rounded-[4px] overflow-hidden border-b-4 border-transparent transition-colors duration-200" style={{
            borderBottomColor: isOpen ? '#C8102E' : 'transparent'
          }} data-id="element-612">
                <button onClick={() => setOpen(isOpen ? null : i)} className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 md:px-6 md:py-5 hover:bg-black/[0.02] transition-colors" aria-expanded={isOpen} data-id="element-613">
                  <span className="font-inter font-semibold text-base md:text-lg text-reach-black" data-id="element-614">
                    {item.q}
                  </span>
                  <ChevronDown size={20} className={`shrink-0 text-reach-red transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-615" />
                </button>
                <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-616">
                  <div className="overflow-hidden" data-id="element-617">
                    <p className="font-inter text-reach-black/80 text-base leading-relaxed px-5 pb-5 md:px-6 md:pb-6 border-t border-black/5 pt-4" data-id="element-618">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-10" data-id="element-619">
          <Link to="/summer-2026" className="btn-secondary" data-id="element-620">
            See all FAQs
            <ArrowRight size={16} className="ml-2" data-id="element-621" />
          </Link>
        </div>
      </div>
    </section>;
}
/* ---------- 10. FINAL CTA ---------- */
function FinalCta() {
  return <section className="bg-reach-red py-16 md:py-20" data-id="element-622">
      <div className="max-w-container mx-auto px-4 md:px-8 text-center" data-id="element-623">
        <h2 className="font-bebas text-white text-5xl md:text-7xl tracking-wide mb-4" data-id="element-624">
          Ready to Start?
        </h2>
        <p className="font-inter text-white text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-625">
          Reserve your athlete's spot for Summer 2026.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center max-w-md sm:max-w-none mx-auto" data-id="element-626">
          <Link to="/pricing" className="inline-flex items-center justify-center bg-white text-reach-black font-inter font-semibold px-6 min-h-[44px] md:min-h-[48px] rounded-[4px] transition-all duration-200 ease-out hover:bg-reach-black hover:text-white uppercase tracking-wide text-sm md:text-base hover:-translate-y-[3px]" data-id="element-627">
            Enroll Now
          </Link>
          <Link to="/book" className="btn-secondary-dark sm:w-auto" data-id="element-628">
            Book Free Consultation
          </Link>
        </div>
      </div>
    </section>;
}